import { Component, Input } from "@angular/core";
import { BrokerStatus } from "../SharedConstants";

@Component({
    selector: "ifbp-submission-status",
    templateUrl: "./submission-status.component.html",
    styleUrls: ["./submission-status.component.scss"],
    standalone: false
})
export class SubmissionStatusComponent {
  @Input() brokerStatus: BrokerStatus;
  readonly BrokerStatus = BrokerStatus;
}
